<template>
  <div id="confirmation" class="">
    <b-container class="container--max-810 mt-6">
      <b-card title="User Information" border-variant="Primary" class="text-center">
        <b-form>
          <b-form-group :label="$t('lang.label_registration_firstName')" label-for="input-first-name" label-cols-sm="5">
            <label class="text-color">{{ userDetails.firstName }}</label>
          </b-form-group>
          <b-form-group :label="$t('lang.label_registration_lastName')" label-for="input-last-name" label-cols-sm="5">
            <label class="text-color">{{ userDetails.lastName }}</label>
          </b-form-group>
          <b-form-group :label="$t('lang.label_registration_orgName')" label-for="input-org-name" label-cols-sm="5">
            <label class="text-color">{{ userDetails.orgName }}</label>
          </b-form-group>
          <b-form-group :label="$t('lang.label_registration_country')" label-for="input-country" label-cols-sm="5">
            <label class="text-color">{{ userDetails.country }}</label>
          </b-form-group>
          <b-form-group :label="$t('lang.label_email')" label-for="label-email" label-cols-sm="5">
            <label id=label-email class="text-color">{{ userDetails.email }}</label>
          </b-form-group>
          <b-form-group :label="$t('lang.label_usage_Reason')" label-for="plans" label-cols-sm="5">
            <label id=plans class="text-color">{{ userDetails.userUsageClaim }}</label>
          </b-form-group>
          <b-row v-if="!this.finished">
            <b-col sm class="text-center mt-4">
              <b-button type="button" variant="danger" @click="deleteUser()">{{
                  $t("lang.button_deleteUser")
                }}
              </b-button>
            </b-col>
            <b-col sm class="text-center mt-4">
              <b-button type="button" variant="success" @click="activateUser()">{{
                  $t("lang.button_activateUser")
                }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>
<script>

import API from "@/api";
import ServerResponse from "@/store/ServerResponse";

export default {
  name: "VerifyAccountActivation",
  data() {
    return {
      userDetails: [],
      finished: false
    }
  },
  methods: {
    getUserToActivate() {
      API.getUserByToken(this.$route.query.token)
          .then(response => {
            this.userDetails = response.data;
          })
          .catch(error => {
            this.$router.push({
                                name: "error",
                                params: {serverResponse: new ServerResponse(error.response.data)}
                              });
          });
    },
    deleteUser() {
      if (confirm(this.$t("lang.confirm_user_delete"))) {
        API.deleteAccount(this.$route.query.token)
            .then(() => {
              this.finished = true;
              this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.button_deleteUser_successful"));
            })
            .catch(error => {
              this.$router.push({
                                  name: "error",
                                  params: {serverResponse: new ServerResponse(error.response.data)}
                                });
            });
      }
    },
    activateUser() {
      if (confirm(this.$t("lang.confirm_user_activate"))) {
        API.activateAccount(this.$route.query.token)
            .then(() => {
              this.finished = true;
              this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.button_activateUser_successful"));
            })
            .catch(error => {
              this.$router.push({
                                  name: "error",
                                  params: {serverResponse: new ServerResponse(error.response.data)}
                                });
            });
      }
    }
  },
  mounted() {
    this.getUserToActivate();
  }
};
</script>
<style scoped></style>
